<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid py-1">
      <ecm-mat-feedback
        [style]="'critical'"
        [title]="error.title"
        [text]="error.description"
        [confirmationLabel]="confirmationLabel"
        (materialFeedbackConfirm)="confirm()"
      >
      </ecm-mat-feedback>
    </div>
  </div>
</div>
